module.exports = __webpack_public_path__ + "img/red_circle.e68452b6.png";